<template>
    <TourLayout
        :config="config"
        :disabled="!selectedTags.length"
        @action-completed="updateSubscriptions"
    >
        <div class="flex flex-col gap-y-8">
            <div
                v-for="group in filteredGroups"
                :key="group.value"
            >
                <div class="text-lg font-medium mb-4">
                    {{ group.title }}
                </div>
                <div class="mb-2 flex flex-wrap gap-2">
                    <DButton
                        v-for="tag in group.options"
                        :key="tag.value"
                        :theme="selectedTags.includes(tag.value) ? 'outline' : 'secondary'"
                        @click="selectTag(tag)"
                    >
                        {{ tag.title }}
                    </DButton>
                </div>
            </div>
        </div>
    </TourLayout>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import { DButton } from '@digistorm/spark'

    import { useTourStore } from '@/stores/tour'
    import api from '@/services/api'
    import { mock } from '@/services'

    import TourLayout from './TourLayout.vue'

    const emit = defineEmits(['action-completed'])

    let controller = null

    const router = useRouter()

    const props = defineProps({
        config: Object,
    })

    const tourStore = useTourStore()
    const moduleHelpers = useModuleHelpers()

    const selectedCategories = ref(tourStore.selectedCategories)

    // Clear out the selected categories
    tourStore.selectedCategories = []

    const selectedTags = ref([])

    const filteredGroups = computed(() => {
        return props.config.layout.data.groups.filter((group) => {
            return selectedCategories.value.includes(group.value) || mock.mockingModule()
        })
    })

    const updateOptions = () => {
        if (controller) {
            controller.abort()
        }

        controller = new AbortController()

        const values = selectedTags.value
        api.patch(
            props.config.layout.data.update_url,
            {
                values,
            },
            {
                signal: controller.signal,
            },
        )
            .then(({ data }) => {
                moduleHelpers.handleActions(router, data.actions)
            })
    }

    const selectTag = (tag) => {
        if (selectedTags.value.includes(tag.value)) {
            selectedTags.value = selectedTags.value.filter((selectedTag) => selectedTag !== tag.value)
        } else {
            selectedTags.value.push(tag.value)
        }
    }

    const updateSubscriptions = () => {
        updateOptions()
        tourStore.handleAction(props.config.action_type, false)
        emit('action-completed')
    }
</script>
